import React from "react";
import FlatButton from "material-ui/FlatButton";
import theme from "../../theme";

export default ({ active, children, ...props }, context) => {
  const style = {
    marginRight: "8px",
    padding: "0 2px",
    borderBottom: active
      ? `2px ${theme.palette.accent1Color} solid`
      : "2px transparent solid"
  };
  return <FlatButton style={style}>{children}</FlatButton>;
};



// WEBPACK FOOTER //
// ./src/components/MenuButton/index.js